import { EndSessionRequest, EventMessage, EventType } from '@azure/msal-browser';
import { Injectable } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { Observable, throwError, Subject } from 'rxjs';
import { catchError, filter, map, takeUntil } from 'rxjs/operators';
import { HttpCemex } from '@cemex-core/angular-services-v8';
import { IamBaseService } from './iam-base.service';
import { MsalErrorConstants } from '../constants/msal-error.constants';

@Injectable({
  providedIn: 'root'
})

export class IamAuthService extends IamBaseService {
  private readonly _destroying$ = new Subject<void>();

  constructor(
    private httpCemex: HttpCemex,
    protected msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService
  ) {
    super(msalService);
  }

  public logoutIAM(urlToRedirect?: string): void {
    sessionStorage.removeItem('loginByIAM');

    const logoutRequest: EndSessionRequest = {};

    if (urlToRedirect) {
      logoutRequest.postLogoutRedirectUri = `${this.getPostLogoutRedirectUri()}?returnUrl=${urlToRedirect}`;
    }

    const signinAccount = this.getSigninAccount();
    if (signinAccount) {
      logoutRequest.account = signinAccount;
    }

    this.msalService.logoutRedirect(logoutRequest).subscribe(
      () => {
        this.msalService.instance.setActiveAccount(null);
      },
      (error) => {
        console.error('Error during logout:', error);
        this.clearSession();
      }
    );
  }

  public handleMsalEvents(): void {
    if (!this.msalBroadcastService.msalSubject$) {
      console.error('msalSubject$ is not initialized');
      return;
    }

    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE),
        takeUntil(this._destroying$)
      )
      .subscribe((result: EventMessage) => {
        console.error('IAM Login failed:', result.error);
        sessionStorage.setItem('errorLogin', MsalErrorConstants.VIEWS_LOGIN_IAM_ERROR_SERVER);
        this.logoutIAM();
      });
  }

  public unsubscribeMsalEvents(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

  public getUserProfile(): Observable<any> {
    const apiUrl: string = this.httpCemex.generateEndpoint('v7/secm/users/profile?include=userinfo,profile,applications,roles,customers');
    return this.httpCemex.get(apiUrl).pipe(
      map((data) => data),
      catchError((error) => this.handleError(error))
    );
  }

  public getConfigurationParametersByCountryAll(): Observable<any> {
    const apiUrl: string = this.httpCemex.generateEndpoint('v4/gm/countries');
    return this.httpCemex.get(apiUrl).pipe(
      map((res) => (res && res['countries'] ? res['countries'] : null)),
      catchError((error) => this.handleError(error))
    );
  }

  private handleError(error: any): Observable<never> {
    return throwError(error || 'Server error');
  }
}
